/* eslint-disable */
import { PropsWithChildren } from "react";

export type SplashMessageProps = {
  backgroundTransparency: 0 | 20 | 30 | 50;
  backgroundColor?: string;
};

export const SplashMessage = ({
  backgroundColor,
  backgroundTransparency,
  children,
}: PropsWithChildren<SplashMessageProps>) => {
  let opacityClass = "bg-opacity-60";

  switch (backgroundTransparency) {
    case 0:
      opacityClass = "bg-opacity-0";
      break;
    case 20:
      opacityClass = "bg-opacity-20";
      break;
    case 30:
      opacityClass = "bg-opacity-30";
      break;
    case 50:
      opacityClass = "bg-opacity-50";
      break;
  }

  const styles: React.CSSProperties = backgroundColor ? { backgroundColor: backgroundColor } : {};

  return (
    <div style={styles} className={`splash-message ${opacityClass}`}>
      {children}
    </div>
  );
};
